// extracted by mini-css-extract-plugin
export default {"all-collections-title":"Collections_all-collections-title__zTidh","allCollectionsTitle":"Collections_all-collections-title__zTidh"};